import { useFormContext } from "react-hook-form";

import Typography from "@components/Typography";

import styles from "../../SignupView.module.css";

const ActivationSent = () => {
  const { getValues } = useFormContext();
  const { email } = getValues();
  return (
    <div
      className={styles.container}
      data-testid="signup-activation-confirmation"
    >
      <Typography variant="h1" block align="center" className={styles.title}>
        {L.SIGN_UP_ACTIVATION_SENT_TITLE}
      </Typography>
      <Typography
        className={styles.activationMessage}
        dangerouslySetInnerHTML={{
          __html: L.SIGN_UP_ACTIVATION_SENT_TEXT.replace(
            "{}",
            `<span data-id="email">${email}</span>`
          ),
        }}
      />
    </div>
  );
};

export default ActivationSent;
